export default __webpack_public_path__ + "static/media/slime_concentrate.15f18e0f.png";